<template>
  <div>
    <h3>Get in touch</h3>

    <form class="rd-mailform" data-form-output="form-output-global" data-form-type="contact" method="post"
          action="src/enrol/vue-components/rd-mailform/rd-mailform.php">
      <div class="form-group">
        <label for="input-name">Name: *</label>
        <div class="position-relative">
          <input v-model="user.name" class="form-control" id="input-name" type="text" name="name"
                 placeholder="Your name" data-constraints="@Required">
        </div>
      </div>
      <div class="form-group">
        <label for="input-email">E-mail: *</label>
        <div class="position-relative">
          <input v-model="user.email" class="form-control" id="input-email" type="email" name="email"
                 placeholder="Your e-mail address" data-constraints="@Email @Required">
        </div>
      </div>
      <div class="form-group">
        <label for="input-email">Mobile:</label>
        <div class="position-relative">
          <input v-model="user.mobile" class="form-control" id="input-mobile" type="tel" name="mobile"
                 placeholder="Your mobile phone number">
        </div>
      </div>
      <div class="form-group">
        <label for="input-question">Question: *</label>
        <div class="position-relative">
                    <textarea v-model="user.message" class="form-control" id="input-question" name="question"
                              placeholder="Your question" data-constraints="@Required"></textarea>
        </div>
      </div>
      <!-- Snackbars-->
      <div v-if="status === 'SUCCESS' " class="snackbar snackbar-primary mt-2">
        <div class="snackbar-inner">
          <div class="snackbar-title"><span class="icon snackbar-icon novi-icon int-check"></span>Message
            sent, we will be in contact with you soon.
          </div>
        </div>
      </div>
      <div v-else-if="status === 'INVALID' " class="snackbar snackbar-danger mt-2">
        <div class="snackbar-inner">
          <div class="snackbar-title">
            <span class="icon snackbar-icon novi-icon int-warning"></span>
            Please fill in the details marked as *
          </div>
          <button class="link link-danger" v-on:click="valid = true">Close</button>
        </div>
      </div>
      <button class="btn btn-lg btn-primary" type="button" v-on:click="submit()">Submit</button>
    </form>
    <div class="form-output snackbar snackbar-secondary" id="form-output-global"></div>
  </div>
</template>

<script>
// import Vue from 'vue'
//todo recaptcha is not working with the Vue 3  yet, need to find out on this
// import {VueReCaptcha} from 'vue-recaptcha-v3'
// Vue.use(VueReCaptcha, {siteKey: '6LfOl7AZAAAAABw6URm9_zSDNH3QD6reGCLOLlHP'})

// import { useReCaptcha } from 'vue-recaptcha-v3'
import EoppService from "@/mixins/EoppService";
import gtmService from "@/services/GoogleTagService";

// const { executeRecaptcha, recaptchaLoaded } = useReCaptcha()

export default {
  name: 'ContactUs',
  mixins: [EoppService],
  components: {
    // quiz
  },
  data() {
    return {
      status: null,
      user: {
        name: null,
        email: null,
        mobile: null,
        message: null
      }
    };
  },
  methods: {
    async submit() {
      console.log(this.user);

      this.status = this.user.name && this.user.email && this.user.message ? 'VALID' : 'INVALID';

      const token = await gtmService.recaptcha();

      if (this.status === 'VALID') {
        // this.postContactUs(this.user, token );
        this.postContactUs(this.user, token).then(res => {
          console.log(res);
          if ((res || {}).data === 'SUCCESS') {
            this.status = 'SUCCESS';
            this.user = {};
          }
        });
      }
    }
  }
}
</script>

<style>

</style>
